import parseMobile from 'libphonenumber-js/mobile';

export const validatePhoneNumber = (
  value: string | null | undefined,
  required?: boolean
) => {
  if (value) {
    const parsedMobile = parseMobile(value, { extract: false });
    return parsedMobile ? parsedMobile.isValid() : false;
  }
  //skip validation if not required
  return required ? false : true;
};
